export default __webpack_public_path__ + "static/media/graph-image.5e88bcb8.png";